export default __webpack_public_path__ + "fan-impeller.png?a0a12aa633e057bbea783254863a04e4";